import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../reduxServer/store";

const ProtectedRoute = ({ children }: any) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.user);

  if (!isAuthenticated) {
    return <Navigate to="/account/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
